import React, { useState, useEffect } from "react";
import { Typography, Container, Box } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import LoaderContainer from "../../components/LoaderContainer";
import CustomButton from "../../components/Custom/CustomButton";
import Calendar from "../../assets/Icon/Calendar.png";
import CustomDetailedList from "../../components/Custom/CustomDetailedList";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { useNavigate } from "react-router-dom";

export default function ProgramManagerMain() {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    try {
      const result = await api.get(`/programs/programs/`);
      setData(result.data);
    } catch (err) {
      alert(
        "Error: " +
          (err.response?.data?.non_field_errors?.[0] || "An error occurred")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAddProgram = () => {
    navigate("/create-program");
  };

  const handleViewProgramDetails = (programId) => {
    navigate(`/program/${programId}`);
  };

  const renderProgramData = (program) => {
    const programInput = program.program_inputs?.[0] || {};
    return [
      {
        label: t("Program Name "),
        value: program.name || t("N/A"),
      },
      {
        label: t("Crops "),
        value: programInput.commodity?.name || t("N/A"),
      },
      {
        label: t("Geographies "),
        value: programInput.states?.name || t("N/A"),
      },
      {
        label: t("Cost to farmer "),
        value: programInput.farmer_cost
          ? `${programInput.farmer_cost} Rs. per acre`
          : t("N/A"),
      },
      {
        label: t("GHG "),
        value: programInput.ghg ? `${programInput.ghg} per acre` : t("N/A"),
      },
      {
        label: t("Water "),
        value: programInput.water ? `${programInput.water} per acre` : t("N/A"),
      },
      {
        label: t("Program end date "),
        value: programInput.program_end_date || t("N/A"),
      },
    ];
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: "91vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CustomTitle>{t("Programs Manager")}</CustomTitle>

          {data.length > 0 ? (
            <>
              <div
                style={{
                  overflowY: "auto",
                  height: "83%",
                  textAlign: "center",
                  maxHeight: "83%",
                  marginTop: "15px",
                }}
              >
                {data.map((program) => (
                  <Box
                    key={program.id}
                    onClick={() => handleViewProgramDetails(program.id)}
                  >
                    <CustomDetailedList
                      id={program.id}
                      data={renderProgramData(program)}
                      buttonList={[]}
                    />
                  </Box>
                ))}
              </div>
              <CustomButton hideIcon onClick={handleAddProgram}>
                {t("Create Program")}
              </CustomButton>
            </>
          ) : (
            <div
              style={{
                height: "85%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  margin: "auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <img
                  src={Calendar}
                  alt="My Programs"
                  style={{
                    width: "127px",
                    height: "127px",
                    marginBottom: "10px",
                  }}
                />

                <CustomButton onClick={handleAddProgram}>
                  {t("Create Program")}
                </CustomButton>

                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, textAlign: "center" }}
                >
                  {t("Your Programs will be shown here once you add them.")}
                </Typography>
              </div>
            </div>
          )}
        </Container>
      </LoaderContainer>
    </>
  );
}
